export const ACCESS = {
  NO_ACCESS: "no_access",
  READ: "read",
  WRITE: "write",
};

export const MODULES = {
  erpag: {
    key: "erpag",
    label: "ERPag",
    resource: "AccessERPag",
  },
  acelynk: {
    key: "acelynk",
    label: "AceLynk",
    resource: "AccessAceLynk",
  },
  planner: {
    key: "planner",
    label: "Operations Planner",
    resource: "AccessPlanner",
  },  
  costing: {
    key: "costing",
    label: "Costing Tool",
    resource: "AccessCosting",
  },
  user_permissions: {
    key: "user_permissions",
    label: "User Permission Management",
    resource: "AccessUserPermissionManagement",
  },
  company_dashboard: {
    key: "company_dashboard",
    label: "Company Dashboard",
    resource: "AccessCompanyDashboard",
  },
  sales: {
    key: "sales",
    label: "Sales",
    resource: "AccessSales",
  },
};

export const MODULE_GROUPS = [
  {
    key: "erpag",
    label: "ERPag",
    moduleResource: "AccessERPag",
    items: [
      { resource: "ERPagDashboard", label: "Dashboard" },
      { resource: "ERPagWorkOrder", label: "Work Order" },
      { resource: "ERPagAlerts", label: "Alerts" },
      { resource: "ERPagAnalytics", label: "Analytics" },
      { resource: "ERPagOnHold", label: "On Hold" },
      { resource: "ERPagTransfers", label: "Transfers" },
      { resource: "ERPagProducts", label: "Products Configuration" },
      { resource: "ERPagAssignedValues", label: "Assigned Values" },
    ],
  },
  {
    key: "acelynk",
    label: "Shipping",
    moduleResource: "AccessAceLynk",
    items: [
      { resource: "ERPagCustomerShippingSchedule", label: "Weekly Planner" },      
      { resource: "AceLynkXML", label: "AceLynk XML" },
    ],
  },
  {
    key: "planner",
    label: "Operations Planner",
    moduleResource: "AccessPlanner",
    items: [

      { resource: "canGroupFamily", label: "Group Family" },
      { resource: "allowBulkEdit", label: "Bulk Edit" },
      { resource: "allowBulkMarkComplete", label: "Bulk Complete" },
      { resource: "allowBulkDelete", label: "Bulk Delete" },      
      
      { resource: "allowEditDeadline", label: "Deadline" },
      { resource: "allowEditCancelDate", label: "Cancel Date" },
      { resource: "allowEditPickupOrShip", label: "PICKUP OR SHIP" },
      { resource: "allowEditAssignedTo", label: "ASSIGNED TO" },

      { resource: "allowEditPaymentTerms", label: "PAYMENT TERMS(PREPAID ONLY)" },
      { resource: "allowEditPlannedProduction", label: "Planned Production" },
      //{ resource: "allowEditPlannedProductionDate", label: "Planned Production Date" },
      { resource: "allowEditPlannedMaterials", label: "Planned Materials" },
      //{ resource: "allowEditPlannedMaterialsDate", label: "Planned Materials Date" },

      { resource: "allowEditPackingLists", label: "PACKED STATUS" },
      { resource: "allowEditShippingStatus", label: "SHIPPED STATUS" },
      { resource: "allowEditInvoiceNumber", label: "INVOICED STATUS" },

      { resource: "allowEditCustomDocs", label: "CUSTOM DOCS" },
      { resource: "allowEditCustomDocsSubmissionDate", label: "SUBMISSION DATE" },

      { resource: "allowEditDeliveryAppointment", label: "DELIVERY APPOINTMENT" },
      //{ resource: "allowEditDeliveryAppointmentDate", label: "Delivery Appointment Date" },
      { resource: "allowEditDeliveryAppointmentTime", label: "Delivery Appointment Time" },
      { resource: "allowEditDeliveryConfirmationNumber", label: "Delivery Confirmation Number" },
      { resource: "allowEditDeliveryAppointmentConfirmed", label: "Delivery Appointment Confirmed" },

      { resource: "allowEditTrackingLink", label: "TRACKING LINK OR PRO/BOL #" },
      { resource: "allowEditDepartureDate", label: "DEPARTURE DATE" },
      { resource: "allowEditEta", label: "ETA" },

      { resource: "allowEditInvoiceSubmission", label: "INVOICE SUBMISSION" },
      { resource: "allowEditInvoiceSubmissionDate", label: "Invoice Submission Date" },

      { resource: "allowMarkComplete", label: "Mark Complete" },
      { resource: "allowDelete", label: "Delete Sales Order" },
    ],
  },  
  {
    key: "costing",
    label: "Costing Tool",
    moduleResource: "AccessCosting",
    items: [
      { resource: "CostingToolPage", label: "Costing Tool" },
      { resource: "CostingGeneratedUPCs", label: "Barcode Center" },
      {
        resource: "CostingGeneratedUPCsEditSKU",
        label: "Barcode SKU Edit",
      },
      { resource: "CostingSettingsPage", label: "Costing Settings" },
      { resource: "CostingBOMDB", label: "BOM DB" },
      {
        resource: "CostingCustomFieldsMandatory",
        label: "Custom Fields Mandatory Toggle",
      },
      { resource: "CostingDetailedCosts", label: "Detailed Costs Breakdown" },
      { resource: "CostingRecipeHistory", label: "Recipe History Tab" },      
    ],
  },
  {
    key: "user_permissions",
    label: "User Permission Management",
    moduleResource: "AccessUserPermissionManagement",
    items: [
      { resource: "UsersPermissionsPage", label: "Users & Permissions Page" },
      { resource: "ManageUsers", label: "Manage Users" },
      { resource: "ManagePermissions", label: "Manage Permissions" },
    ],
  },
  {
    key: "company_dashboard",
    label: "Company Dashboard",
    moduleResource: "AccessCompanyDashboard",
    items: [
      { resource: "CompanyDashboard", label: "Dashboard" }
    ],
  },
  {
    key: "sales",
    label: "Sales",
    moduleResource: "AccessSales",
    items: [
      { resource: "SalesAutomatedPO", label: "Automated PO Entry" },
      { resource: "SalesAnalytics", label: "Sales Analytics" },
      { resource: "ExportExcel", label: "Export Excel" },
      { resource: "SalesERPag", label: "ERPAG" },
      { resource: "SalesAmazon", label: "Amazon" },
      { resource: "SalesShopify", label: "Shopify" },
      { resource: "SalesWalmart", label: "Walmart" }
    ],
  },
];

export const ROUTE_REQUIREMENTS = {
  "/dashboard": { module: "AccessERPag", page: "ERPagDashboard" },
  "/workorder": { module: "AccessERPag", page: "ERPagWorkOrder" },
  "/alerts": { module: "AccessERPag", page: "ERPagAlerts" },
  "/analytics": { module: "AccessERPag", page: "ERPagAnalytics" },
  "/on-hold": { module: "AccessERPag", page: "ERPagOnHold" },
  "/transfers": { module: "AccessERPag", page: "ERPagTransfers" },
  "/products": { module: "AccessERPag", page: "ERPagProducts" },
  "/products-settings": { module: "AccessERPag", page: "ERPagAssignedValues" },
  "/customer-shipping-schedule": {
    module: "AccessERPag",
    page: "ERPagCustomerShippingSchedule",
  },
  "/UserAndPermissionsManagement": {
    module: "AccessUserPermissionManagement",
    page: "UsersPermissionsPage",
  },
  "/acelynk": { module: "AccessAceLynk", page: "AceLynkXML" },
  "/costing-tool": { module: "AccessCosting", page: "CostingToolPage" },
  "/generated-upcs": { module: "AccessCosting", page: "CostingGeneratedUPCs" },
  "/costing-settings": { module: "AccessCosting", page: "CostingSettingsPage" },
  "/bom-db": { module: "AccessCosting", page: "CostingBOMDB" },
  "/company-dashboard": { module: "AccessCompanyDashboard", page: "CompanyDashboard" },
  "/sales-automated-po": { module: "AccessSales", page: "SalesAutomatedPO" },
  "/sales-analytics": { module: "AccessSales", page: "SalesAnalytics" },
  "/sales-erpag": { module: "AccessSales", page: "SalesERPag" },
  "/sales-amazon": { module: "AccessSales", page: "SalesAmazon" },
  "/sales-shopify": { module: "AccessSales", page: "SalesShopify" },
  "/sales-walmart": { module: "AccessSales", page: "SalesWalmart" },
};

export const normalizeAccess = (value) => {
  if (value === ACCESS.READ || value === ACCESS.WRITE || value === ACCESS.NO_ACCESS) {
    return value;
  }
  if (value === true) return ACCESS.WRITE;
  return ACCESS.NO_ACCESS;
};

export const canReadAccess = (value) => normalizeAccess(value) !== ACCESS.NO_ACCESS;
export const canWriteAccess = (value) => normalizeAccess(value) === ACCESS.WRITE;
